import * as React from 'react';

const SvgVegan: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width={24}
      height={24}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z"
        fill="currentColor"
      />
      <path
        d="M11.03 8.19l-1.8 4.91-1.82-4.91H5.5l3.03 7.39h1.4l2.99-7.39h-1.89zM18.11 12.71c0-1.74-1.2-2.75-2.77-2.75-1.74 0-2.89 1.24-2.89 2.87 0 1.49.95 2.87 3 2.87 1.02 0 1.87-.36 2.4-.76l-.62-1.07c-.44.3-1.12.53-1.71.53-.85 0-1.32-.43-1.49-1.03h4.03c.03-.22.05-.44.05-.66zm-2.77-1.48c.66 0 1.12.4 1.26 1.02h-2.58c.18-.64.68-1.02 1.32-1.02z"
        fill="white"
      />
    </svg>
  );
};

export default SvgVegan;
